export default __webpack_public_path__ + "static/media/defects.88e0afc4.svg";